import Job from './Job.vue'

export default Job
